import { render, staticRenderFns } from "./BtnSaldoProjetoAcao.vue?vue&type=template&id=31496554&"
import script from "./BtnSaldoProjetoAcao.vue?vue&type=script&lang=js&"
export * from "./BtnSaldoProjetoAcao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports